import moment from "moment";

export const formatDate = (
  dateString: string,
  format: string = "MMM D, YYYY"
) => {
  return moment
    .utc(dateString)
    .local()
    .format(format);
};

export const formatDateWithoutLocal = (
  dateString: string,
  format: string = "MMM D, YYYY"
) => {
  return moment.utc(dateString).format(format);
};

export const dateToFormatString = (
  date: Date,
  format: string = "YYYY-MM-DD"
) => {
  return moment(date).format(format);
};

/**
 * Parses a date-only string (e.g. "2026-08-01") as LOCAL midnight instead of
 * UTC midnight. Using `new Date("2026-08-01")` directly parses it as UTC,
 * which then shifts to the previous day when displayed in timezones behind
 * UTC (e.g. US timezones). Use this helper anywhere a "YYYY-MM-DD" string
 * needs to become a `Date` for display in a date picker, comparisons, etc.
 */
export const parseDateOnlyLocal = (dateString?: string | null): Date | null => {
  if (!dateString) return null;
  // moment parses "YYYY-MM-DD" (no timezone info) in local time by default.
  const parsed = moment(dateString, "YYYY-MM-DD", true);
  return parsed.isValid() ? parsed.toDate() : null;
};

export const dateToFormatStringISO8601 = (date: Date) => {
  return moment(date).format();
};

export const getDifferenceWithCurrentDate = (dateString: string) => {
  return moment(dateString).fromNow();
};

export const getDifferenceWithTime = (dateString?: string) => {
  const date = moment(dateString);
  return `${date.fromNow()} ${date.format("h:mm a")}`;
};

export const sortDates = (dateA?: string, dateB?: string) => {
  if (!dateA) return 1;
  if (!dateB) return -1;

  const closestADate = moment(dateA);
  const closestBDate = moment(dateB);

  return closestADate.isBefore(closestBDate)
    ? -1
    : closestADate.isAfter(closestBDate)
    ? 1
    : 0;
};

export const secondsToHms = (d:number) => {     
  let h = Math.floor(d / 3600);     
  let m = Math.floor(d % 3600 / 60);     
  let s = Math.floor(d % 3600 % 60);      
  let hDisplay = h > 0 ? h + (h == 1 ? " hr" : " hrs") + (m > 0 || s > 0 ? ", ":"") : "";     
  let mDisplay = m > 0 ? m + (m == 1 ? " min" : " mins") + (s > 0 ? ", ":"") : "";     
  let sDisplay = s > 0 ? s + (s == 1 ? " sec" : " secs") : "";       
  return hDisplay + mDisplay + sDisplay; 
}
